import axios from "axios";

/**
 * Fetches the latest discount for the given publisher + customer (sale) or publisher + supplier (purchase).
 * Used to prefill the Add/Edit form in Discount Master.
 * @returns {Promise<object|null>} The discount object or null
 */
export const getDiscountByPublisherAndParty = (params) => {
	return async () => {
		try {
			const { discount_type, publisher_id, customer_id, supplier_id } = params;
			const searchParams = new URLSearchParams({
				discount_type,
				publisher_id,
			});
			if (discount_type === "sale" && customer_id) {
				searchParams.append("customer_id", customer_id);
			}
			if (discount_type === "purchase" && supplier_id) {
				searchParams.append("supplier_id", supplier_id);
			}
			const { data } = await axios.get(`discount-master/by-publisher-party?${searchParams.toString()}`);
			return data;
		} catch (error) {
			console.log(error.message);
			return null;
		}
	};
};
